enum Provider {
    OTHER = 'Other',
    KBS = 'Kbs',
    IO = 'Io',
    ERS = 'Ers',
}

export default Provider;